/* PARWIN: hide filter/sort UI on small collections (clutter on few-product pages) */
(function () {
  if (window.__parwinColl) return; window.__parwinColl = true;
  function run() {
    if (location.pathname.indexOf('/collections/') !== 0) return;
    var grid = document.querySelector('.resource-list--grid');
    if (!grid) return;
    var n = grid.querySelectorAll('product-card').length;
    if (n > 0 && n < 7) {
      ['.facets', '.facets-mobile-wrapper', '.facets-toggle', '.facets-controls-wrapper']
        .forEach(function (sel) {
          document.querySelectorAll(sel).forEach(function (el) { el.style.display = 'none'; });
        });
    }
  }
  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
})();
